import { QueryFilter, SortState } from '@fox/data-grid';

export const FILTER_MIN_WIDTH = '300px';
export type SwiftFoxActionCentreResult = {
	data: Record<string, string>[];
	totalResults: number;
};

export type RenderType = 'hyperlink' | 'image' | undefined;
type TitleField = {
	columnId: string;
	renderType?: RenderType;
};
type CardField = TitleField & {
	hideColumnName?: boolean;
};

type DrawerField = CardField & {
	fieldGroup?: string;
};

export type CardViewSettings = {
	drawerTitle?: string;
	thumbnailField?: string;
	titleFields?: TitleField[];
	cardFields?: CardField[];
	drawerFields?: DrawerField[];
};
export type SwiftFoxActionCentreColumnsResult = {
	columns: ActionCentreColumn[];
	name: string;
	cardViewSettings?: CardViewSettings;
};

export type ActionCentreColumn = {
	id: string;
	title: string;
	type: string; //i.e custom
	filterType: string;
	sortIndex?: string;
	filterGroup?: string;
	filterable?: boolean;
	customFieldMetadata?: string;
};

// Utility function to filter out image/thumbnail columns for table view and exports
export function filterOutImageColumns(columns: ActionCentreColumn[], cardViewSettings?: CardViewSettings): ActionCentreColumn[] {
	return columns?.filter(column => {
		// Exclude column if it matches the thumbnailField
		const isThumbnailField = cardViewSettings?.thumbnailField === column.id;
		
		// Exclude columns with renderType 'image' in cardFields or drawerFields
		const hasImageRenderType = 
			cardViewSettings?.cardFields?.some(field => field.columnId === column.id && field.renderType === 'image') ||
			cardViewSettings?.drawerFields?.some(field => field.columnId === column.id && field.renderType === 'image') ||
			cardViewSettings?.titleFields?.some(field => field.columnId === column.id && field.renderType === 'image');
		
		return !hasImageRenderType && !isThumbnailField;
	}) || [];
}

export type ActionCentreDataInputModel = {
	contentId: string;
	id: string;
	page?: number;
	pageSize?: number;
	sourceFilter?: string;
	sort?: SortState;
	filters?: QueryFilter[];
};

export interface IActionCentreTableProps {
	actionId: string;
	rowsExpandedOnSmallScreens: boolean;
	disableExport?: boolean;
	filterPositioning?: 'Top' | 'Left' | undefined;
	itemsPerPage?: number;
	displayMode?: 'Table (default)' | 'Cards' | undefined;
}

export interface IActionCentreViewProps {
	actionId: string;
	columnsResult: SwiftFoxActionCentreColumnsResult;
	sourceOptions: [string, string][];
	showFilters: boolean;
	disableExport: boolean;
	pageSize: number;
	showSearch: boolean;
	rowsExpandedOnSmallScreens: boolean;
	displayMode?: 'Table (default)' | 'Cards' | undefined;
}
